import React from 'react';
import { Box, Skeleton, Grid, Card, CardContent } from '@mui/material';

/**
 * Loading skeleton for location list view
 */
export const ListSkeleton = ({ rows = 5 }) => (
  <Box>
    {Array.from({ length: rows }).map((_, i) => (
      <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.5, px: 2 }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={24} />
          <Skeleton variant="text" width="25%" height={18} />
        </Box>
        <Skeleton variant="rounded" width={60} height={24} />
      </Box>
    ))}
  </Box>
);

/**
 * Loading skeleton for card grid view
 */
export const CardGridSkeleton = ({ count = 8 }) => (
  <Grid container spacing={2}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Skeleton variant="rounded" width={40} height={40} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="70%" height={24} />
                <Skeleton variant="text" width="40%" height={18} />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Skeleton variant="rounded" width={80} height={24} />
              <Skeleton variant="rounded" width={60} height={24} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
);

/**
 * Loading skeleton for detail panel
 */
export const DetailSkeleton = () => (
  <Box sx={{ p: 3 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Skeleton variant="rounded" width={48} height={48} />
      <Box>
        <Skeleton variant="text" width={200} height={32} />
        <Skeleton variant="text" width={120} height={20} />
      </Box>
    </Box>
    <Skeleton variant="rounded" width="100%" height={200} />
  </Box>
);

export default { ListSkeleton, CardGridSkeleton, DetailSkeleton };
